var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5103_13718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.001 17.25C16.2962 17.2492 17.5707 17.4018 18.8262 17.707C20.0787 18.0116 21.3171 18.4659 22.541 19.0752V19.0762C22.9791 19.3029 23.3294 19.6283 23.6016 20.0713C23.8681 20.5052 24.0006 20.9739 24 21.499V22.5C24 22.9204 23.862 23.2556 23.5586 23.5596C23.2561 23.8626 22.9216 24.0005 22.501 24H7.5C7.07973 24 6.74524 23.8623 6.44238 23.5596C6.17733 23.2945 6.03789 23.0043 6.00684 22.6533L6 22.499V21.5C6 20.9734 6.13306 20.5043 6.39941 20.0713C6.63787 19.6837 6.93624 19.386 7.30078 19.165L7.46094 19.0752C8.68415 18.4648 9.92135 18.0097 11.1729 17.707C12.4291 17.4032 13.7049 17.2508 15.001 17.25ZM15 6C16.1077 6 17.0311 6.38265 17.8242 7.17578C18.6173 7.96891 19 8.89233 19 10C19 11.1077 18.6173 12.0311 17.8242 12.8242C17.0311 13.6173 16.1077 14 15 14C13.8923 14 12.9689 13.6173 12.1758 12.8242C11.3827 12.0311 11 11.1077 11 10C11 8.89233 11.3827 7.96891 12.1758 7.17578C12.9194 6.43212 13.7777 6.04974 14.7949 6.00488L15 6Z",
    stroke: "white",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5103_13718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/Members.e5614f21f900180b9f4868b5a333757a.svg";
export { ForwardRef as ReactComponent };